import { render, staticRenderFns } from "./MglVectorLayer.vue?vue&type=template&id=dde8468a"
import script from "./MglVectorLayer.vue?vue&type=script&lang=js"
export * from "./MglVectorLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports